import React from 'react'
import LinearProgress from 'material-ui-legacy/LinearProgress'
import {pinkA200} from 'material-ui-legacy/styles/colors'

const LinearLoader = (props) => (
  <LinearProgress
    mode="indeterminate"
    color={props.color || pinkA200}
  />
)

export default LinearLoader


// WEBPACK FOOTER //
// ./src/components/UI/LinearLoader.jsx